import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Capacity from '../../entities/casis/capacity'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'

interface CapacityState extends ListState<Capacity>{
    editModel:Capacity;
    
}
class CapacityModule extends ListModule<CapacityState,any,Capacity>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<Capacity>(),
        loading:false,
        editModel: new Capacity(),
        activeList: new Array<Capacity>(),
        path: 'capacities'          
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions
        async create(context: ActionContext<CapacityState, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.post('/api/' + (context.state as any).path, payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            return response.data.result;
        },
        async updateBatch(context: ActionContext<CapacityState, any>, payload: any) {
            context.state.loading = true;
            await Ajax.put('/api/capacity-batch', payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
        },
        async export(context: ActionContext<CapacityState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/capacities/export', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            return reponse.data.result.filename;
        },
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
        edit(state: CapacityState, model: Capacity) {
            state.editModel = model;
            
        }, 
        new(state: CapacityState, model: Capacity) {
            state.editModel = Object.assign({});
        },
    });
}
const capacityModule=new CapacityModule();
export default capacityModule;
